export default [
  {
    path: '/admin/setup-offers',
    name: 'setup-offer',
    meta: { requiresAuth: true },
    component: () => import('@/pages/website/setup-offer/index.vue')
  }
]
